import { Component, ElementRef, HostBinding } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "th[resizable]",
  templateUrl: "./resizable.component.html",
  styleUrls: ["./resizable.component.scss"],
})
export class ResizableComponent {

  @HostBinding("style.width.px")
  width: number | null = null;

  public getUpdatedWidth = new BehaviorSubject<number | null>(this.width);
  public GetUpdatedWidth = this.getUpdatedWidth.asObservable();

  onResize(width: number) {
    this.width = width;
    this.getUpdatedWidth.next(this.width);
  }
}
